export default __webpack_public_path__ + "static/media/closet5-after2-1920w.f03e47f1.webp";